"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMESSA_ITEM_SEM_CADASTRO = exports.PV_ITEM_SEM_ROTEIRO = exports.PV_ITEM_SEM_CADASTRO = exports.PRAZOS_FILTRO_PV = exports.SITUACOES_PV = void 0;
/**
 * Situação DERIVADA do PV (12-04, PV-05): nunca é gravada. A regra vive só em
 * `apps/api/src/modules/vendas/pedido-venda-saldos.sql.ts` (`SQL_SITUACAO_PV`).
 */
exports.SITUACOES_PV = ['ABERTO', 'EM_RECEBIMENTO', 'EM_PRODUCAO', 'PARCIALMENTE_FATURADO', 'CONCLUIDO', 'CANCELADO'];
exports.PRAZOS_FILTRO_PV = ['TODOS', 'ATRASADOS', 'PROXIMOS_7', 'PERIODO'];
// ---------------------------------------------------------------------------------------------
// Fase 17.3, Plano 03 (D-25): produto sem cadastro nunca e esquecido — codigos de erro, atalhos e "Cadastrar peca".
// ---------------------------------------------------------------------------------------------
/** 409 de "Gerar OP" quando o item do PV nao tem Material (produto sem cadastro). */
exports.PV_ITEM_SEM_CADASTRO = 'PV_ITEM_SEM_CADASTRO';
/** 409 de "Gerar OP" quando a peca nao tem roteiro vigente. */
exports.PV_ITEM_SEM_ROTEIRO = 'PV_ITEM_SEM_ROTEIRO';
/** 400 de `POST /remessas` com item sem cadastro: a pendencia ficou registrada na Central de Pendencias. */
exports.REMESSA_ITEM_SEM_CADASTRO = 'REMESSA_ITEM_SEM_CADASTRO';
//# sourceMappingURL=vendas.js.map